import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

function CheckEmailPage() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                px: 2,
                bgcolor: 'background.default',
            }}
        >
            <Paper
                sx={{
                    width: '100%',
                    maxWidth: 400,
                    p: { xs: 4, sm: 6 },
                    borderRadius: 3,
                    boxShadow: 3,
                    textAlign: 'center',
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                    <img
                        src="/assets/images/logo/logo.svg"
                        alt="Company Logo"
                        style={{ width: 100 }}
                    />
                </Box>

                <Typography variant="h6" sx={{ mb: 2 }}>
                    Check Your Email
                </Typography>

                <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
                    We have sent an email to your registered address. Please click the link in the email
                    to complete your login.
                    <strong> The link will expire in 5 minutes</strong>.
                </Typography>

                <Typography variant="body2" sx={{ mt: 2 }}>
                    Didn’t receive the email?
                    Check your spam folder or try resending the magic link.
                </Typography>
            </Paper>
        </Box>
    );
}

export default CheckEmailPage;
